import { render, staticRenderFns } from "./Hot_lookreport.vue?vue&type=template&id=6f120753"
import script from "./Hot_lookreport.vue?vue&type=script&lang=js"
export * from "./Hot_lookreport.vue?vue&type=script&lang=js"
import style0 from "./Hot_lookreport.vue?vue&type=style&index=0&id=6f120753&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports